import { Violation } from '@/lib/models/user-event';
import Chip from '.';
import { FC } from 'react';
import { ChipSize } from './helpers';

interface Props {
  violation: Violation;
  size?: ChipSize;
}

const violationLabel = (violation: Violation) => {
  if (violation === Violation.CONFIDENTIAL_DATA) {
    return 'Confidential';
  }
  return violation;
};

const ViolationChip: FC<Props> = ({ violation, size = 'small' }) => (
  <Chip label={violationLabel(violation)} color="error" size={size} />
);

export default ViolationChip;
